/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Weekday_DefaultInputs */

const en_notify_weekday_default = /** @type {(inputs: Notify_Weekday_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household shopping day`)
};

const de_notify_weekday_default = /** @type {(inputs: Notify_Weekday_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkaufstag des Haushalts`)
};

/**
* | output |
* | --- |
* | "Household shopping day" |
*
* @param {Notify_Weekday_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_weekday_default = /** @type {((inputs?: Notify_Weekday_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Weekday_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_weekday_default(inputs)
	return en_notify_weekday_default(inputs)
});